import AlreadyLoggedWeightToday from "./AlreadyLoggedWeightToday";

export default AlreadyLoggedWeightToday;
